import SelectItemSheet, {
  Item,
} from "@coworker/apprestructured/src/task-management/components/SelectItemSheet/SelectItemSheet";
import { useMemo } from "react";
import { useTranslation } from "@coworker/locales";

export type ScheduleSaveDecision = "this" | "all";

type ScheduleSaveDeciderProps = {
  visible: boolean;
  onClose: () => void;
  onConfirmClick: () => void;
  decision: ScheduleSaveDecision;
  onDecisionChange: (newDecision: ScheduleSaveDecision) => void;
};

function ScheduleSaveDecider({
  visible,
  onClose,
  onConfirmClick,
  decision,
  onDecisionChange,
}: ScheduleSaveDeciderProps) {
  const { t } = useTranslation();

  const items = useMemo<Item<ScheduleSaveDecision>[]>(() => {
    return [
      {
        label: t("thisTaskString"),
        value: "this",
      },
      {
        label: t("allUnfinishedTasksInSeriesString"),
        value: "all",
      },
    ];
  }, [t]);

  return (
    <SelectItemSheet
      title={t("applyChangesToString")}
      items={items}
      visible={visible}
      itemValue={decision}
      onItemValueChange={onDecisionChange}
      onConfirmClick={onConfirmClick}
      onClose={onClose}
    />
  );
}

export default ScheduleSaveDecider;
